import 'core-js/fn/array/find-index';
import 'core-js/fn/array/find';

/*
	This class is for implementing keyboard (arrow key) navigation. 

	It organizes all elements into horizontal rows (which the user defines explicitly).
	Left/right move within a "row".

	Up/down move between rows. The nearest element horizontally is chosen, based on actual element position.

	It uses "keys" to logically identify elements. These keys can be anything, and will be compared for strict equality.
*/

function getCenterX(element) {
	const rect = element.getBoundingClientRect();
	return rect.left + rect.width/2;
}
function orderHorizontally(focus_children) {
	focus_children.sort((c1, c2) => getCenterX(c1.element) - getCenterX(c2.element));
}

export default class FocusManager {
	constructor(on_focus_changed) {
		this.on_focus_changed = on_focus_changed;

		this.wraps_horizontally = true;
		this.wraps_vertically = false;

		this.focus_children = [];
		this.focused_child_key = null;

		window.addEventListener('keydown', this._handle_keydown.bind(this));
	}
	// call with element = null to remove focusability
	register(key, row_level, element) {
		const {focus_children, focused_child_key} = this;

		const index = focus_children.findIndex(child => child.key === key);

		// we are de-registering this item
		if (element === null) {
			// ensure item is still in list
			if (index >= 0) {
				const child = focus_children[index];

				// unfocus child, if necessary
				if (child.key === focused_child_key) {
					this._set_focused(null);
				}

				// remove child from array
				focus_children.splice(index, 1);
			}
		}
		// adding or changing item
		else {
			const new_child = {
				key: key,
				row_level: row_level,
				element: element,
			};
			if (index >= 0) {
				focus_children[index] = new_child;
			}
			else {
				focus_children.push(new_child);
			}
		}
	}
	move(direction) {
		// TODO
		console.log(direction);

		const {focus_children, focused_child_key} = this;

		if (focus_children.length === 0) {
			return;
		}

		if (focused_child_key === null) {
			// nothing is focused - start with upper-right element
			const row_level = this._get_levels()[0];
			const candidates = this._children_in_level(row_level);
			this._set_focused(candidates[0].key);
			return;
		}

		const focused_child = focus_children.find(c => c.key === focused_child_key);

		if (direction === 'right') {
			const candidates = this._children_in_level(focused_child.row_level);
			const index = candidates.findIndex(c => c === focused_child);
			if (index === candidates.length-1) {
				if (this.wraps_horizontally) {
					this._set_focused(candidates[0].key);
				}
			}
			else {
				this._set_focused(candidates[index+1].key)
			}
		}
		else if (direction === 'left') {
			const candidates = this._children_in_level(focused_child.row_level);
			const index = candidates.findIndex(c => c === focused_child);
			if (index === 0) {
				if (this.wraps_horizontally) {
					this._set_focused(candidates[candidates.length-1].key);
				}
			}
			else {
				this._set_focused(candidates[index-1].key);
			}
		}
		else if (direction === 'up' || direction === 'down') {
			const levels = this._get_levels();
			const level_index = levels.findIndex(rl => rl === focused_child.row_level)

			let target_level_index = null;

			if (direction === 'up') {
				if (level_index === 0) {
					if (this.wraps_vertically) {
						target_level_index = levels.length-1;
					}
				}
				else {
					target_level_index = level_index-1;
				}
			}
			// direction is down
			else {
				if (level_index === levels.length-1) {
					if (this.wraps_vertically) {
						target_level_index = 0;
					}
				}
				else {
					target_level_index = level_index+1;
				}
			}

			if (target_level_index === null) {
				// we don't support wrapping
				return;
			}

			const center_x = getCenterX(focused_child.element);
			const candidates = this._children_in_level(levels[target_level_index]);
			let closest_distance = null;
			let closest = null;
			candidates.forEach(focus_child => {
				const distance = Math.abs(getCenterX(focus_child.element) - center_x);
				if (closest_distance === null || distance < closest_distance) {
					closest_distance = distance;
					closest = focus_child;
				}
			});
			this._set_focused(closest.key);
		}
	}
	_get_levels() {
		// extract row_levels
		const levels = this.focus_children.map(c => c.row_level);
		// sort ascending
		levels.sort((a, b) => a-b)
		// eliminate duplicates
		return levels.filter((element, index, array) => index === 0 || element !== array[index-1]);
	}
	_children_in_level(row_level) {
		const result = this.focus_children.filter(c => c.row_level === row_level);
		orderHorizontally(result);
		return result;
	}
	_set_focused(key) {
		this.focused_child_key = key;
		this.on_focus_changed(key);
	}
	_handle_keydown(event) {
		switch (event.key) {
			case 'ArrowRight':
			case 'Right': // for IE
				this.move('right');
				break;
			case 'ArrowLeft':
			case 'Left': // for IE
				this.move('left');
				break;
			case 'ArrowUp':
			case 'Up': // for IE
				this.move('up');
				break;
			case 'ArrowDown':
			case 'Down': // for IE
				this.move('down');
				break;
			default:
				break;
		}
	}
}


// WEBPACK FOOTER //
// ./src/FocusManager.js